import React, { Fragment, useState } from "react";
import { useFormikContext } from "formik";
import { useSelector } from "react-redux";
import BlockList from "components/FormerEditor/BlockList";
import BlockSettings from "components/FormerEditor/BlockSettings";
import Preview from "components/FormerEditor/Preview";
import AddEntityBlockItem from "components/FormerEditor/AddEntityBlockItem";
import ThemeBlockItem from "components/FormerEditor/ThemeBlockItem";
import PreviewLoader from "components/FormerEditor/EditorLoader/PreviewLoader";
import BlockPicker from "components/FormerEditor/BlockPicker";
import PageTheme from "components/FormerEditor/PageTheme";
import { BUILDER_INTENT } from "utils/constants/builder";
import { STATE_KEYS } from "utils/constants/state";
import get from "lodash/get";
import HoverIconButton from "components/HoverIconButton";
import Overlay from "components/Overlay";
import { COLORS } from "utils/styles";

const PANEL_INTENT_MAP = {
  [BUILDER_INTENT.ENTITY_ADD]: BlockPicker,
  [BUILDER_INTENT.ENTITY_SETTINGS]: BlockSettings,
  [BUILDER_INTENT.PAGE_THEME]: PageTheme
};

const MobilePageBuilder = () => {
  const { values } = useFormikContext();
  const [showOverlay, setShowOverlay] = useState(false);
  const { appLoading } = useSelector((state) => {
    return {
      appLoading: Boolean(state.getIn(["app", "isLoading"]))
    };
  });

  let panel;
  let panelBlock;
  if (get(values, STATE_KEYS.EDITOR.VISIBILITY_PANEL)) {
    const IntentComp = PANEL_INTENT_MAP[get(values, STATE_KEYS.EDITOR.INTENT)];
    if (IntentComp) {
      panel = <IntentComp />;
    }
    panelBlock = (
      <div className="bg-content--secondary w-100 h-100 bh--inset overflow-y-scroll-ns">
        {panel}
      </div>
    );
  }

  const activeBlock = get(values, STATE_KEYS.EDITOR.ACTIVE_BLOCK);

  let content = null;
  if (!activeBlock) {
    content = (
      <Fragment>
        <AddEntityBlockItem name={STATE_KEYS.EDITOR.ACTIVE_BLOCK} />
        <ThemeBlockItem name={STATE_KEYS.EDITOR.ACTIVE_BLOCK} />
        <BlockList name={STATE_KEYS.EDITOR.ACTIVE_BLOCK} />
      </Fragment>
    );
  } else {
    content = panelBlock;
  }

  return (
    <div className="flex flex-column w-100">
      <div className="flex flex-row justify-between items-center bg-white bb hairline-1 pv2 sticky top-0 z-1">
        <div className="f6 pl3 fw5 ">Preview page</div>
        <div className="pr3">
          <HoverIconButton
            color={COLORS.blue}
            onClick={() => setShowOverlay(true)}
            type="eye"
          />
        </div>
      </div>
      {content}
      {showOverlay && (
        <Overlay hideOverlay={() => setShowOverlay(false)}>
          <div className="w-100 bg-content--secondary overflow-y-scroll-ns overflow-x-hidden">
            {appLoading ? <PreviewLoader /> : <Preview />}
          </div>
        </Overlay>
      )}
    </div>
  );
};

export default MobilePageBuilder;
